import React from 'react';
import styled from '@emotion/native';
import { TouchableOpacity } from 'react-native';
import { BodyText } from '@/shared/components/StyledText';
import { mint, lightGreen, red, green, sand } from '@/shared/styles/colors';
import { formatNoteTimestamp } from './helpers';
import { ClientNote } from '@/shared/types/generated';

interface NoteListItemProps {
  note: ClientNote;
  onRemove: (noteId: number) => void;
  isRemoving?: boolean;
}

const NoteListItem: React.FC<NoteListItemProps> = ({
  note,
  onRemove,
  isRemoving = false,
}) => {
  const handleRemove = () => {
    if (!isRemoving) {
      onRemove(note.id);
    }
  };

  return (
    <Container>
      <HeaderContainer>
        <TimestampText>{formatNoteTimestamp(note.createdAt)}</TimestampText>
        <TouchableOpacity onPress={handleRemove} disabled={isRemoving}>
          <RemoveText isRemoving={isRemoving}>
            {isRemoving ? 'Removing...' : 'Remove'}
          </RemoveText>
        </TouchableOpacity>
      </HeaderContainer>

      <ContentContainer>
        <ContentText>{note.content}</ContentText>
      </ContentContainer>
    </Container>
  );
};

export default NoteListItem;

const Container = styled.View({
  width: '100%',
  backgroundColor: mint,
  borderRadius: 4,
  borderWidth: 1,
  borderColor: mint,
  marginBottom: 16,
  overflow: 'hidden',
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 20,
});

const HeaderContainer = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: mint,
  paddingVertical: 8,
});

const TimestampText = styled(BodyText)({
  fontFamily: 'Lora',
  fontSize: 14,
  color: green,
  fontWeight: '500',
  letterSpacing: -0.14,
});

const RemoveText = styled(BodyText)<{ isRemoving: boolean }>(
  ({ isRemoving }) => ({
    fontSize: 12,
    color: isRemoving ? lightGreen : red,
    fontWeight: 'bold',
    textDecorationLine: isRemoving ? 'none' : 'underline',
  }),
);

const ContentContainer = styled.View({
  paddingHorizontal: 20,
  paddingVertical: 12,
  backgroundColor: sand,
  borderRadius: 4,
});

const ContentText = styled(BodyText)({
  fontSize: 14,
  lineHeight: 20,
  color: green,
});
